import {format, Params} from "./format";
import {language} from "./language";

// A message's forms by count, as Intl.PluralRules names them. English needs one and other; other languages add
// zero, two, few or many, and fall back to other for any they leave out.
export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string };

const rules = new Intl.PluralRules(language);

// The form for count, with its {placeholders} filled: {count} is the count itself.
export function plural(count: number, forms: PluralForms, params?: Params): string {
    return format(forms[rules.select(count)] ?? forms.other, { count, ...params });
}
